import { BarChartConstants } from "./dashboard-bar.chart.constants";
import { DashboardBarOrientation } from "./dashboard-bar.chart.models";

/**
 * For each bar value, whether its label fits inside the bar (drawn centered) vs.
 * just outside a too-short bar. Pre-computed once so the datalabels
 * anchor/align/color callbacks don't each re-derive it per bar.
 */
export const getInsideLabelFlags = (
  values: number[],
  maxValue: number,
  orientation: DashboardBarOrientation,
): boolean[] =>
  values.map(
    value =>
      maxValue > 0 &&
      value / maxValue >= BarChartConstants.insideLabelMinRatio[orientation],
  );

/** Datalabel alignment for a bar, given whether its label sits inside the bar. */
export const getBarLabelAlign = (
  inside: boolean,
  isHorizontal: boolean,
  isRtl: boolean,
): "start" | "center" | "end" => {
  if (isHorizontal) {
    // In RTL the value axis is reversed, so the inside/outside sides flip.
    if (inside) {
      return isRtl ? "end" : "start";
    }
    return isRtl ? "start" : "end";
  }
  return inside ? "center" : "end";
};
